export const UserRoleName = {
  Onboarding: "onboarding",
};
